export default __webpack_public_path__ + "static/media/Coiled Serpent Ring.38613bd6.jpg";